import type { Id } from 'convex/_generated/dataModel';
import type { Garden } from '@modules/garden-planner/business_logic';

export function createHandleClearAllPlants(
  selectedGarden: Garden | null | undefined,
  updateGarden: (args: {
    gardenId: Id<'gardens'>;
    plants: Array<{ row: number; col: number; slot: number; plantId: string }>;
  }) => Promise<unknown>
) {
  return async () => {
    if (!selectedGarden) return;
    await updateGarden({ gardenId: selectedGarden._id, plants: [] });
  };
}
